import React from 'react';

const Glossary = () => {
    return (
        <div className="p-10 text-center text-gray-500 dark:text-gray-400">
            Glossar-Funktion kommt in Kürze.
        </div>
    );
};

export default Glossary;
